import * as angular from "angular";
angular.module("rhUtils", ["ng", "ngRoute"]);
